import { useCallback } from "react";

import { useLayerAttributeOptions } from "../../../hooks/attributes/useLayerAttributeOptions";
import { useCurrentLayerName } from "../../../hooks/layer/useCurrentLayer";
import { useClassesRecalc } from "./useClassesRecalc";
import { AttributeOption } from "../../../evergis/core/attributes/createAttributeOption";
import { ClassificationParameter } from "../../../interfaces/classification";
import { ClassificationValueUpdate } from "../../../ducks/classification/classification";

export const useClassifyByAttribute = (
  parameter: ClassificationParameter,
): [AttributeOption[], (option: AttributeOption[]) => void] => {
  const layerName = useCurrentLayerName();
  const options = useLayerAttributeOptions(layerName);
  const { calculateClassesRange } = useClassesRecalc();

  const selectOption = useCallback(
    ([{ value }]: AttributeOption[]) => {
      calculateClassesRange({
        field: value as ClassificationValueUpdate["field"],
        parameter,
      });
    },
    [calculateClassesRange, parameter],
  );

  return [options, selectOption];
};
